import * as React from 'react';
import { CPPElements } from 'rcd-cpp-docs';
import { getToken } from '../../utils/authClient';

export const Toasters = () => {
  const cppToasters = React.useRef<CPPElements.Toasters>(null);
  React.useEffect(() => {
    if (cppToasters.current) {
      cppToasters.current.getToken = getToken;
    }
  }, []);

  return <cpp-toasters ref={cppToasters} id="cppToasters"></cpp-toasters>;
};
